import { useState, useEffect, useContext } from 'react';
import type { Target } from '@retro-ui/api-contract';

import { TargetValidationContext } from '@f/context';

export interface SmilesError {
  index: number;
  smiles: string;
  message: string;
}

export type TargetValidation = ReturnType<typeof useTargetValidation>;

export function useTargetValidation(targets: Target[] | null) {
  const { validateTargets } = useContext(TargetValidationContext);

  const [generalError, setGeneralError] = useState<string>();
  const [smilesErrors, setSmilesErrors] = useState<SmilesError[]>([]);

  useEffect(() => {
    validateTargets(targets)
      .then(errors => {
        setSmilesErrors(errors);
        setGeneralError(undefined);
      })
      .catch(error => {
        setGeneralError(error.message);
      });
  }, [targets]);

  return { generalError, smilesErrors };
}
